<!-- <label class="gender-header">Choose Gender</label> -->
<div>
  <!-- <mat-radio-group aria-label="Select an option" formControlName="gender">
    <mat-radio-button
      *ngFor="let gender of genderList"
      value="{{ gender?.id }}"
      [checked]="gender?.name === 'Male'"
      [ngClass]="{
        'is-gender': gender?.name === 'Female'
      }"
      >{{ gender?.name }}</mat-radio-button
    >
  </mat-radio-group> -->
  <mat-form-field appearance="outline" class="mat-input-custom">
    <mat-label>Select Gender</mat-label>
    <mat-select [formControlName]="formControlNameData">
      <mat-option *ngFor="let gender of genderList" [value]="gender?.name">
        <!-- {{ gender?.name }} -->
        <!-- <p> -->
        {{
          gender?.name
            ? gender?.name.charAt(0).toUpperCase() +
              gender?.name.slice(1).toLowerCase()
            : ""
        }}
        <!-- </p> -->
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="form.controls['formControlNameData']?.hasError('required')"
    >
      This is a required field.
    </mat-error>
  </mat-form-field>
</div>
